import {SSEDataAdapter} from "./SSEDataAdapter.js";
import type {SessionItem} from "../session/SessionItem.js";
import {ref} from "vue";
import {MessageFactory} from "../factory/MessageFactory.js";

export class MCFCopilotSSEAdapter extends SSEDataAdapter {

    private session: SessionItem
    private pushMsg = false

    constructor(session: SessionItem) {
        super();
        this.session = session;
    }

    on_error_msg(data: string): void {
        this.session.lastMessage.isStreaming = false;
        this.session.lastMessage.content = data
    }

    on_success_msg(data: string): void {

        const MSG_TYPE = {
            // 服务状态
            STATUS: "status",
            // 图表数据
            TABLE: "table",
            // 统计图
            CHARTS: "charts",
            CHARTS_TITLE: "charts_title",
            // 文本
            TEXT: "text",
        }

        const res = JSON.parse(data)
        if (res.msg_type === MSG_TYPE.STATUS) this.stateEvent(res.msg)
        else if (res.msg_type === MSG_TYPE.TABLE) this.tableEvent(res.msg)
        else if (res.msg_type === MSG_TYPE.CHARTS_TITLE) this.chartsTitleEvent(res.msg)
        else if (res.msg_type === MSG_TYPE.CHARTS) this.chartsEvent(res.msg)
        else if (res.msg_type === MSG_TYPE.TEXT) this.textEvent(res.msg)

    }

    stateEvent(state: string) {
        if(this.pushMsg) {
            const newMsg = ref(MessageFactory.createAiMsg())
            newMsg.value.isStreaming = true
            this.session.pushMessage(newMsg.value)
            this.pushMsg = false
        }

        let aiMsg = this.session.lastMessage
        aiMsg.statusText = state

    }

    tableEvent(data: any): void {

        let aiMsg = this.session.lastMessage

        aiMsg.isStreaming = false

        aiMsg.msgType = '1'
        aiMsg.chartData = data.data || []
        aiMsg.field = data.field || []

        this.pushMsg = true

    }

    chartsTitleEvent(title: string){
        let aiMsg = this.session.lastMessage
        aiMsg.title = title
    }

    chartsEvent(data: any) {

        let aiMsg = this.session.lastMessage
        aiMsg.msgType = data.type
        aiMsg.chartData = data.data || []
        aiMsg.isStreaming = false

        this.pushMsg = true

    }

    textEvent(data: string) {
        let aiMsg = this.session.lastMessage
        aiMsg.isStreaming = false
        aiMsg.msgType = "0"
        aiMsg.content += data
    }

}